<template>
  <div
    class="border-b px-4 py-5 sm:rounded-t-lg sm:px-6"
    :class="{
      'border-b-neutral-200': variant === 'plain',
      'border-b-sky-200 bg-sky-50': variant === 'info',
      'border-b-yellow-200 bg-yellow-50': variant === 'warn',
    }"
  >
    <slot>
      <div class="flex flex-wrap items-center justify-between gap-y-2">
        <h3 class="flex min-w-fit flex-1 items-center gap-2 text-lg font-medium leading-6 text-neutral-900">
          <InformationCircleIcon v-if="variant === 'info'" class="h-6 w-6 shrink-0 text-sky-500" aria-hidden="true" />
          <ExclamationTriangleIcon
            v-if="variant === 'warn'"
            class="h-6 w-6 shrink-0 text-yellow-500"
            aria-hidden="true"
          />
          {{ title }}
        </h3>
        <div class="ml-4 flex min-w-fit flex-wrap items-start justify-start gap-4 print:hidden">
          <slot name="actions"></slot>
          <router-link v-if="viewAllTo" class="text-sm text-sky-500 hover:underline" :to="viewAllTo"
            >View All</router-link
          >
        </div>
      </div>
    </slot>
  </div>
</template>

<script lang="ts">
import type { LandingCardVariant } from "@/components/landing/landingCard";
import { ExclamationTriangleIcon, InformationCircleIcon } from "@heroicons/vue/24/outline";
import { defineComponent, type PropType } from "vue";
import type { RouteLocationAsPathGeneric, RouteLocationAsRelativeGeneric } from "vue-router";

export default defineComponent({
  name: "LandingCard",
  components: { ExclamationTriangleIcon, InformationCircleIcon },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    viewAllTo: {
      type: Object as PropType<string | RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric>,
      required: false,
      default: null,
    },
    variant: {
      type: String as PropType<LandingCardVariant>,
      required: false,
      default: "plain",
    },
  },
});
</script>
